export const isMobile = () => /Mobi|Android/i.test(navigator.userAgent);
